module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "parent",
    staticClass: "cb-header__wrap cb-transition__slide",
    attrs: {
      "id": "cb-header-wrap",
      "role": "banner"
    }
  }, [_c('cb-slide-n-fade', [(_vm.showLogo) ? _c('div', {
    staticClass: "cb-header__logo cb-transition__slide"
  }, [_c('img', {
    staticClass: "cb-header__image",
    attrs: {
      "src": _vm.logo,
      "alt": "logo"
    }
  })]) : _vm._e()]), _vm._v(" "), _c('cb-slide-n-fade', [(this.$route.meta.isHeaderTitle || !(this.$route.meta.headerLogo && _vm.logo)) ? _c('div', {
    ref: "x",
    staticClass: "cb-header__title cb-transition__slide",
    class: {
      'cb-header__title--xl': !(this.$route.meta.showCheckoutSteps && _vm.checkout_steps.length > 1) && !(this.$route.meta.headerLogo && _vm.logo)
    },
    style: (_vm.themeColor),
    attrs: {
      "id": "cb-header-title"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.header) + "\n    ")]) : _vm._e()]), _vm._v(" "), _c('cb-slide-n-fade', [(this.$route.meta.showCheckoutSteps && _vm.checkout_steps.length > 1) ? _c('div', {
    staticClass: "cb-header__wizard cb-transition__slide",
    attrs: {
      "id": "cb-header-wizard"
    }
  }, _vm._l((_vm.checkout_steps), function(i) {
    return _c('div', {
      key: i,
      staticClass: "cb-header__button",
      class: {
        'cb-header__button--active': _vm.current_checkout_step == i
      },
      style: (_vm.backgroundColor)
    })
  })) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cfe3fca2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/collections/headers/Type1.vue
// module id = 171
// module chunks = 66 68 69